package org.moxultimate.topwithmox.shows.ui

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.shows.data.ShowsResponse

/**
 * ShowsState
 * Screen states for the Shows page driven by [ShowsViewModel].
 */
@Immutable
sealed class ShowsState {
    data object Loading : ShowsState()
    data class Error(val error: String, val statusCode: Int = 0) : ShowsState()
    data class Success(
        val showsList: List<ShowsResponse>,
        val hasMore: Boolean = true,
    ) : ShowsState()
}
